import {
    useEffect,
    useState,
} from "react";

import {
    Dialog,
    Portal,
    Box,
    Text,
    Input,
    Button,
    VStack,
    HStack,
    Grid,
    Flex,
    Alert,
} from "@chakra-ui/react";

import {
    UserPlus,
    X,
    ArrowLeft,
} from "lucide-react";

import {
    useDispatch,
} from "react-redux";

import {
    toaster,
} from "../../components/toaster";

import ActivityToast from "../../components/ActivityToast";

import {
    registerDriverAction,
} from "../../state/actions/driverPartnerActions";


const RegisterDriverModal = ({
    open,
    onClose,
    onRegistered,
}) => {
    const dispatch = useDispatch();

    const [
        form,
        setForm,
    ] = useState({
        username: "",
        email: "",
        phone_number: "",
    });

    const [
        loading,
        setLoading,
    ] = useState(false);

    const [
        showConfirmation,
        setShowConfirmation,
    ] = useState(false);


    useEffect(() => {
        if (open) {
            setForm({
                username: "",
                email: "",
                phone_number: "",
            });

            setShowConfirmation(false);
            setLoading(false);
        }
    }, [open]);


    const handleChange = (
        field,
        value
    ) => {
        setForm(
            (prev) => ({
                ...prev,
                [field]: value,
            })
        );
    };


    const isValidEmail = (
        email
    ) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            email.trim()
        );
    };
    const isValidUsername = (
    username
) => {
    return /^[A-Za-z0-9_]{3,15}$/.test(
        username.trim()
    );
};

const isFormValid = () => {
    const username =
        form.username.trim();

    const email =
        form.email.trim();

    const phone =
        form.phone_number.trim();

    return (
        isValidUsername(username) &&
        isValidEmail(email) &&
        /^\d{8}$/.test(phone)
    );
};


    const handleContinue = () => {
        const username =
            form.username.trim();
            if (!username) {
    toaster.create({
        render: () => (
            <ActivityToast
                type="error"
                title="Username Required"
                description="Please enter the driver's username."
                timestamp="Just now"
            />
        ),
    });

    return;
}

if (!isValidUsername(username)) {
    toaster.create({
        render: () => (
            <ActivityToast
                type="error"
                title="Invalid Username"
                description="Username must be 3–15 characters and may only contain letters, numbers, or underscores."
                timestamp="Just now"
            />
        ),
    });

    return;
}

        const email =
            form.email.trim();

        const phone =
            form.phone_number.trim();





        if (!email) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Email Required"
                        description="Please enter the driver's email address."
                        timestamp="Just now"
                    />
                ),
            });

            return;
        }


        if (!isValidEmail(email)) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Invalid Email"
                        description="Please enter a valid email address, for example driver@example.com."
                        timestamp="Just now"
                    />
                ),
            });

            return;
        }


        if (!phone) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Phone Number Required"
                        description="Please enter the driver's 8-digit phone number."
                        timestamp="Just now"
                    />
                ),
            });

            return;
        }


        if (!/^\d{8}$/.test(phone)) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Invalid Phone Number"
                        description="Please enter a valid 8-digit Botswana phone number."
                        timestamp="Just now"
                    />
                ),
            });

            return;
        }


        setShowConfirmation(true);
    };


    const handleRegister = async () => {
        const payload = {
            username:
                form.username.trim(),

            email:
                form.email
                    .trim()
                    .toLowerCase(),

            phone_number:
                `+267${form.phone_number}`,
        };


        setLoading(true);

        try {
            const result =
                await dispatch(
                    registerDriverAction(
                        payload
                    )
                );


            if (result?.success) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Driver Registered"
                            description="The driver account has been created and the login credentials have been sent to the driver's email."
                            timestamp="Just now"
                        />
                    ),
                });

                if (onRegistered) {
                    onRegistered();
                }

                setForm({
                    username: "",
                    email: "",
                    phone_number: "",
                });


                setShowConfirmation(false);

                onClose();

            } else {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Registration Failed"
                            description={
                                result?.error ||
                                "Unable to register driver."
                            }
                            timestamp="Just now"
                        />
                    ),
                });
            }

        } finally {
            setLoading(false);
        }
    };


    const handleBack = () => {
        if (!loading) {
            setShowConfirmation(false);
        }
    };


    return (
        <Dialog.Root
            open={open}
            onOpenChange={(e) => {
                if (
                    !e.open &&
                    !loading
                ) {
                    onClose();
                }
            }}
        >

            <Portal>

                <Dialog.Backdrop
                    bg="blackAlpha.600"
                    backdropFilter="blur(4px)"
                />

                <Dialog.Positioner
                    p={{
                        base: 4,
                        md: 6,
                    }}
                >

                    <Dialog.Content
                        w="100%"
                        maxW={{
                            base: "95vw",
                            md: "700px",
                        }}
                        maxH="90vh"
                        borderRadius={{
                            base: "18px",
                            md: "24px",
                        }}
                        overflow="hidden"
                    >

                        {/* HEADER */}

                        <Dialog.Header
                            borderBottom="1px solid"
                            borderColor="gray.200"
                            px={{
                                base: 4,
                                md: 6,
                            }}
                            py={{
                                base: 4,
                                md: 5,
                            }}
                        >

                            <Flex
                                justify="space-between"
                                align="flex-start"
                                gap={4}
                                w="100%"
                            >

                                <HStack
                                    gap={3}
                                    flex="1"
                                    minW={0}
                                    align="flex-start"
                                >

                                    {showConfirmation ? (
                                        <Box
                                            cursor={
                                                loading
                                                    ? "not-allowed"
                                                    : "pointer"
                                            }
                                            onClick={
                                                handleBack
                                            }
                                        >
                                            <ArrowLeft
                                                size={22}
                                                color="#2453FF"
                                            />
                                        </Box>
                                    ) : (
                                        <UserPlus
                                            size={22}
                                            color="#2453FF"
                                        />
                                    )}


                                    <Box flex="1">

                                        <Text
                                            fontWeight="700"
                                            fontSize={{
                                                base: "md",
                                                md: "lg",
                                            }}
                                        >
                                            {showConfirmation
                                                ? "Confirm Driver Details"
                                                : "Register Driver"}
                                        </Text>


                                        <Text
                                            fontSize="sm"
                                            color="gray.500"
                                        >
                                            {showConfirmation
                                                ? "Please review the information before registering the driver."
                                                : "Create a driver account and link it to your recruitment profile."}
                                        </Text>

                                    </Box>

                                </HStack>


                                <Box
                                    cursor={
                                        loading
                                            ? "not-allowed"
                                            : "pointer"
                                    }
                                    onClick={() => {
                                        if (!loading) {
                                            onClose();
                                        }
                                    }}
                                    flexShrink={0}
                                >
                                    <X size={20} />
                                </Box>

                            </Flex>

                        </Dialog.Header>


                        {/* BODY */}

                        <Dialog.Body
                            px={{
                                base: 4,
                                md: 6,
                            }}
                            py={{
                                base: 4,
                                md: 6,
                            }}
                            overflowY="auto"
                        >

                            {!showConfirmation ? (

                                <VStack
                                    align="stretch"
                                    gap={6}
                                >

                                    {/* INFORMATION */}

                                    <Alert.Root
                                        status="info"
                                        borderRadius="12px"
                                        bg="#F5F8FF"
                                        border="1px solid"
                                        borderColor="#D6E4FF"
                                    >

                                        <Alert.Indicator />

                                        <Box>

                                            <Text
                                                fontWeight="600"
                                            >
                                                Driver Account Information
                                            </Text>

                                            <Text
                                                fontSize="sm"
                                                color="gray.600"
                                            >
                                                Once the driver account has
                                                been created, the login
                                                credentials will be sent to
                                                the driver by email. The driver
                                                can then log in using the
                                                Mogoma mobile app and will be
                                                guided through the account
                                                activation process before
                                                completing onboarding.
                                            </Text>

                                        </Box>

                                    </Alert.Root>


                                    {/* DRIVER DETAILS */}

                                    <Box>

                                        <Text
                                            fontSize="xs"
                                            fontWeight="700"
                                            color="gray.500"
                                            letterSpacing="1px"
                                            mb={3}
                                        >
                                            DRIVER ACCOUNT DETAILS
                                        </Text>


                                        <Grid
                                            templateColumns={{
                                                base: "1fr",
                                                md: "1fr 1fr",
                                            }}
                                            gap={4}
                                        >

                                            {/* USERNAME */}

                                            <Box>

                                                <Text
                                                    mb={2}
                                                    fontSize="sm"
                                                    fontWeight="600"
                                                >
                                                    Username
                                                </Text>


                                             <Input
    value={form.username}
    placeholder="driver.username"
    maxLength={15}
    onChange={(e) =>
        handleChange(
            "username",
            e.target.value
                .replace(/\s+/g, "_")
                .slice(0, 15)
        )
    }
/>

{form.username.trim() &&
    !isValidUsername(
        form.username
    ) && (
        <Text
            mt={1}
            fontSize="xs"
            color="red.500"
        >
            Use 3–15 characters: letters,
            numbers, or underscores.
            Example: John_Doe. Avoid spaces.
        </Text>
    )}

                                            </Box>


                                            {/* EMAIL */}

                                            <Box>

                                                <Text
                                                    mb={2}
                                                    fontSize="sm"
                                                    fontWeight="600"
                                                >
                                                    Email Address
                                                </Text>


                                                <Input
                                                    type="email"
                                                    value={
                                                        form.email
                                                    }
                                                    placeholder="driver@email.com"
                                                    onChange={(e) =>
                                                        handleChange(
                                                            "email",
                                                            e.target.value
                                                        )
                                                    }
                                                    borderColor={
                                                        form.email &&
                                                        !isValidEmail(
                                                            form.email
                                                        )
                                                            ? "red.400"
                                                            : undefined
                                                    }
                                                />


                                                {form.email &&
                                                !isValidEmail(
                                                    form.email
                                                ) ? (
                                                    <Text
                                                        mt={1}
                                                        fontSize="xs"
                                                        color="red.500"
                                                    >
                                                        Please enter a valid
                                                        email address.
                                                    </Text>
                                                ) : null}

                                            </Box>


                                            {/* PHONE */}

                                            <Box>

                                                <Text
                                                    mb={2}
                                                    fontSize="sm"
                                                    fontWeight="600"
                                                >
                                                    Phone Number
                                                </Text>


                                                <Input
                                                    size="lg"
                                                    placeholder="71234567"
                                                    value={
                                                        form.phone_number
                                                    }
                                                    onChange={(e) =>
                                                        handleChange(
                                                            "phone_number",
                                                            e.target.value
                                                                .replace(
                                                                    /\D/g,
                                                                    ""
                                                                )
                                                                .slice(
                                                                    0,
                                                                    8
                                                                )
                                                        )
                                                    }
                                                    maxLength={8}
                                                />


                                                {form.phone_number &&
                                                !/^\d{8}$/.test(
                                                    form.phone_number
                                                ) ? (
                                                    <Text
                                                        mt={1}
                                                        fontSize="xs"
                                                        color="red.500"
                                                    >
                                                        Enter an 8-digit
                                                        Botswana phone number.
                                                    </Text>
                                                ) : null}

                                            </Box>

                                        </Grid>

                                    </Box>


                                    {/* RECRUITMENT NOTICE */}

                                    <HStack
                                        p={4}
                                        bg="#F8FAFC"
                                        borderRadius="12px"
                                        align="flex-start"
                                    >

                                        <UserPlus
                                            size={18}
                                            color="#2453FF"
                                        />

                                        <Text
                                            fontSize="sm"
                                            color="gray.600"
                                        >
                                            This driver will automatically
                                            be linked to your recruitment
                                            profile and become eligible for
                                            milestone commissions.
                                        </Text>

                                    </HStack>

                                </VStack>

                            ) : (

                                /* CONFIRMATION */

                                <VStack
                                    align="stretch"
                                    gap={5}
                                >

                                    <Alert.Root
                                        status="warning"
                                        borderRadius="12px"
                                    >

                                        <Alert.Indicator />

                                        <Box>

                                            <Text
                                                fontWeight="600"
                                            >
                                                Confirm Registration
                                            </Text>

                                            <Text
                                                fontSize="sm"
                                                color="gray.600"
                                            >
                                                Please make sure the
                                                information below is correct.
                                                The driver account will be
                                                created using these details.
                                            </Text>

                                        </Box>

                                    </Alert.Root>


                                    <Box
                                        border="1px solid"
                                        borderColor="gray.200"
                                        borderRadius="14px"
                                        overflow="hidden"
                                    >

                                        <Flex
                                            justify="space-between"
                                            align="center"
                                            px={5}
                                            py={4}
                                            borderBottom="1px solid"
                                            borderColor="gray.100"
                                            gap={4}
                                        >

                                            <Text
                                                fontSize="sm"
                                                color="gray.500"
                                            >
                                                Username
                                            </Text>

                                            <Text
                                                fontWeight="600"
                                                textAlign="right"
                                                wordBreak="break-word"
                                            >
                                                {
                                                    form.username
                                                }
                                            </Text>

                                        </Flex>


                                        <Flex
                                            justify="space-between"
                                            align="center"
                                            px={5}
                                            py={4}
                                            borderBottom="1px solid"
                                            borderColor="gray.100"
                                            gap={4}
                                        >

                                            <Text
                                                fontSize="sm"
                                                color="gray.500"
                                            >
                                                Email Address
                                            </Text>

                                            <Text
                                                fontWeight="600"
                                                textAlign="right"
                                                wordBreak="break-word"
                                            >
                                                {
                                                    form.email
                                                }
                                            </Text>

                                        </Flex>


                                        <Flex
                                            justify="space-between"
                                            align="center"
                                            px={5}
                                            py={4}
                                            gap={4}
                                        >

                                            <Text
                                                fontSize="sm"
                                                color="gray.500"
                                            >
                                                Phone Number
                                            </Text>

                                            <Text
                                                fontWeight="600"
                                            >
                                                +267
                                                {
                                                    form.phone_number
                                                }
                                            </Text>

                                        </Flex>

                                    </Box>


                                    <Text
                                        fontSize="sm"
                                        color="gray.500"
                                        textAlign="center"
                                    >
                                        The driver's temporary login
                                        credentials will be generated
                                        securely and sent to the driver's
                                        email after registration.
                                    </Text>

                                </VStack>

                            )}

                        </Dialog.Body>


                        {/* FOOTER */}

                        <Dialog.Footer
                            px={{
                                base: 4,
                                md: 6,
                            }}
                            py={{
                                base: 4,
                                md: 5,
                            }}
                            borderTop="1px solid"
                            borderColor="gray.200"
                        >

                            {!showConfirmation ? (

                                <Flex
                                    ml="auto"
                                    w="100%"
                                    gap={3}
                                    direction={{
                                        base: "column-reverse",
                                        sm: "row",
                                    }}
                                >

                                    <Button
                                        flex="1"
                                        w="100%"
                                        size="lg"
                                        minH="44px"
                                        variant="outline"
                                        onClick={onClose}
                                        disabled={loading}
                                    >
                                        Cancel
                                    </Button>


                                    <Button
                                        flex="1"
                                        w="100%"
                                        size="lg"
                                        minH="44px"
                                        bg="#2453FF"
                                        color="white"
                                        _hover={{
                                            bg: "#1E46D8",
                                        }}
                                        onClick={
                                            handleContinue
                                        }
                                        disabled={
                                            !isFormValid() ||
                                            loading
                                        }
                                    >
                                        Review Details
                                    </Button>

                                </Flex>

                            ) : (

                                <Flex
                                    ml="auto"
                                    w="100%"
                                    gap={3}
                                    direction={{
                                        base: "column-reverse",
                                        sm: "row",
                                    }}
                                >

                                    <Button
                                        flex="1"
                                        w="100%"
                                        size="lg"
                                        minH="44px"
                                        variant="outline"
                                        onClick={
                                            handleBack
                                        }
                                        disabled={loading}
                                    >
                                        Go Back
                                    </Button>


                                    <Button
                                        flex="1"
                                        w="100%"
                                        size="lg"
                                        minH="44px"
                                        bg="#2453FF"
                                        color="white"
                                        _hover={{
                                            bg: "#1E46D8",
                                        }}
                                        loading={loading}
                                        loadingText="Registering..."
                                        onClick={
                                            handleRegister
                                        }
                                    >
                                        Confirm & Register
                                    </Button>

                                </Flex>

                            )}

                        </Dialog.Footer>

                    </Dialog.Content>

                </Dialog.Positioner>

            </Portal>

        </Dialog.Root>
    );
};


export default RegisterDriverModal;